const mainButtons = document.querySelectorAll(".main-button")


const mainButtonInit = () =>{
  for(let i = 0; i <  mainButtons.length; i++){
    const articleName = mainButtons[i].classList[2];
    const popoutPost = document.querySelector(`.home-article.${articleName}`);
    const popoutBkg = document.querySelector(`.home-article.${articleName} .home-article-bkg`);
    const popoutX = document.querySelector(`.home-article.${articleName} .x-button`);
    const popoutInner = document.querySelector(`.home-article.${articleName} .home-article-inner`);

    if (popoutPost === null || popoutBkg === null || popoutX === null || popoutInner === null){
      console.log(`could not find appropriate article for ${articleName}`)
    } else {
      mainButtons[i].addEventListener('click', () =>{
        popoutPost.classList.remove('hidden');
        void popoutInner.offsetWidth;        
        popoutInner.classList.add('popout-expand');
      });
      popoutBkg.addEventListener('click', () =>{
        popoutInner.classList.remove('popout-expand');
        setTimeout(()=> {
          popoutPost.classList.add('hidden');
        }, 400);
      });
      popoutX.addEventListener('click', () =>{
        popoutInner.classList.remove('popout-expand');
        setTimeout(()=> {
          popoutPost.classList.add('hidden');
        }, 400);
      });
    }
  }

}

const initialize = () => {
  mainButtonInit();
}

initialize();